/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Ben_Faster_EbInputs */

const en_funnel_ob_ben_faster_eb = /** @type {(inputs: Funnel_Ob_Ben_Faster_EbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You want to get through more`)
};

const es_funnel_ob_ben_faster_eb = /** @type {(inputs: Funnel_Ob_Ben_Faster_EbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quieres avanzar más`)
};

/**
* | output |
* | --- |
* | "You want to get through more" |
*
* @param {Funnel_Ob_Ben_Faster_EbInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_ben_faster_eb = /** @type {((inputs?: Funnel_Ob_Ben_Faster_EbInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Ben_Faster_EbInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_ben_faster_eb(inputs)
	return en_funnel_ob_ben_faster_eb(inputs)
});